module.exports = __webpack_public_path__ + "static/media/reportar-problema.e73ef20c.svg";